import React, {createContext} from 'react';
import {AppBar, Box, Toolbar, useMediaQuery, useTheme} from '@mui/material';
import {css} from '@emotion/css';
import AccountMenu from './AccountMenu';
import {SHORT_SCREEN_MEDIA_QUERY} from '../constants';

interface Props {
  children: React.ReactNode;
  /** Receives the element left of the account menu, which views portal their own header controls into via `HeaderSlotContext`. */
  slotRef?: (el: HTMLElement | null) => void;
}

export const HeaderSlotContext = createContext<HTMLElement | null>(null);

const ARE_TOOLBAR_POINTER_EVENTS_DISABLED = true;

function HeaderWrapper({children, slotRef}: Props) {
	const theme = useTheme();
	/** Short viewports (e.g. phone landscape) pull the header controls tight into the top corners. */
	const isShortScreen = useMediaQuery(SHORT_SCREEN_MEDIA_QUERY);
	const classes = {
		menu: css`
		& > div {
		}
		& > div > button.MuiButton-text {
		  padding: ${theme.spacing(1, 2)};
		  border-radius: 0;
		}
		`
	};
	return <>
		<AppBar position="fixed" color='transparent' style={{backgroundImage: 'none', boxShadow: 'none', border: 'none'}} sx={{backgroundColor: 'transparent', backdropFilter: 'none', pointerEvents: ARE_TOOLBAR_POINTER_EVENTS_DISABLED ? 'none' : 'all'}}>
			<Toolbar
				disableGutters={isShortScreen}
				// `&&` outranks the Toolbar's own min-height media queries.
				sx={isShortScreen ? {'&&': {minHeight: 0}, pt: 1.5, px: 1.5} : undefined}
			>
				<Box display='flex' justifyContent='space-between' alignItems='center' sx={{width:'100%'}} className={classes.menu} gap={1}>
					{children}
					<Box flex={1} display='flex' justifyContent='flex-end' alignItems='center'>
						<Box ref={slotRef} display='flex' alignItems='center' sx={{pointerEvents: 'all'}} />
						<AccountMenu areToolbarPointerEventsDisabled={ARE_TOOLBAR_POINTER_EVENTS_DISABLED} />
					</Box>
				</Box>
			</Toolbar>
		</AppBar>
	</>;
}

export default HeaderWrapper;
